module.exports = {
  name: 'ru',
  months: ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'],
  monthsShort: ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'],
  days: ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'],
  daysShort: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
  thousandSeparator: ' ',
  decimalSeparator: ',',
  formats: {
    'General Number': '#.#',
    'Currency': '#,##0.00р.;[Red]-#,##0.00р.',
    'Fixed': '0.00',
    'Standard': '#,##0.00',
    'Percent': '0.00%',
    'Scientific': '0.00E+00',
    'Yes/No': '"Да";"Да";"Нет"',
    'True/False': '"Истина";"Истина";"Ложь"',
    'On/Off': '"Вкл";"Вкл";"Выкл"',
    'Short Date': 'mm.dd.yyyy',
    'Long Date': 'dd mmmm yyyy',
    'General Date': 'mm.dd.yyyy h:mm',
    'Medium Date': 'dd.mmm.yy',
    'Long Time': 'hh:mm:ss AM/PM',
    'Short Time': 'h:mm',
    'Medium Time': 'hh:mm AM/PM'
  }
};



// WEBPACK FOOTER //
// ./src/locales/ru.js